import _ from 'lodash';
import React from 'react';
import Immutable from 'immutable';
import Prism from 'prismjs';
import classNames from 'classnames';
import highlightingTheme from './highlighting-theme.scss';

const DEFAULT_SYNTAX = 'javascript';
const CODE_TOKEN_CLASS_NAMES = {
  keyword: 'button-color',
  operator: 'button-color',
  function: 'icon-secondary-color',
  constant: 'icon-secondary-color',
  'class-name': 'icon-secondary-color',
  boolean: 'forum-editor-code-value-color',
  string: 'forum-editor-code-value-color',
  number: 'forum-editor-code-value-color',
  regex: 'forum-editor-code-value-color',
  variable: 'forum-editor-code-value-color',
  'template-string': 'forum-editor-code-value-color',
};

export default class PrismDecorator {
  highlighted = {};

  getDecorations(block) {
    const blockKey = block.getKey();
    const blockText = block.getText();
    const decorations = Array(blockText.length).fill(null);

    this.highlighted[blockKey] = {};

    if (block.getType() !== 'code-block') {
      return Immutable.List(decorations); // eslint-disable-line new-cap
    }

    // Parse text using Prism
    const grammar = Prism.languages[DEFAULT_SYNTAX];
    const tokens = Prism.tokenize(blockText, grammar);
    let offset = 0;

    for (let i = 0; i < tokens.length; i++) {
      const token = tokens[i];

      if (typeof token === 'string') {
        offset += token.length;
      } else {
        const tokenId = `tok${offset}`;
        const resultId = `${blockKey}-${tokenId}`;

        this.highlighted[blockKey][tokenId] = token;

        addDecorations(decorations, offset, offset + getTokenLength(token), resultId);
        offset += getTokenLength(token);
      }
    }

    return Immutable.List(decorations); // eslint-disable-line new-cap
  }

  getComponentForKey() {
    return props => {
      const { type } = props; // eslint-disable-line react/prop-types
      const className = classNames(CODE_TOKEN_CLASS_NAMES[type], highlightingTheme[type]);
      return <span {...props} className={className}/>;
    };
  }

  getPropsForKey(key) {
    const parts = key.split('-');
    const blockKey = parts[0];
    const tokId = parts[1];
    const { type } = this.highlighted[blockKey][tokId];
    return {
      type,
    };
  }
}

function getTokenLength(token) {
  const tokenContent = token.content || token;
  if (typeof tokenContent === 'string') {
    return tokenContent.length;
  }

  return _.reduce(token.content, (acc, token) => getTokenLength(token) + acc, 0);
}

function addDecorations(decorations, start, end, componentKey) {
  for (let i = start; i < end; i++) {
    decorations[i] = componentKey;
  }
}



// WEBPACK FOOTER //
// ./app/components/text-editor/plugins/code-block/highlighting-decorator.js